export default function assertExhaustive(_val: never): never {
  throw new Error('This should never happen');
}
